import { render, staticRenderFns } from "./DnAdditionalIds.vue?vue&type=template&id=3c8f9188&scoped=true&"
import script from "./DnAdditionalIds.vue?vue&type=script&lang=js&"
export * from "./DnAdditionalIds.vue?vue&type=script&lang=js&"
import style0 from "./DnAdditionalIds.vue?vue&type=style&index=0&id=3c8f9188&lang=scss&scoped=true&"
import style1 from "./DnAdditionalIds.vue?vue&type=style&index=1&id=3c8f9188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f9188",
  null
  
)

export default component.exports